<script lang="ts">
  import { APP_MODE, caps } from '../config.svelte';
  import { LOCALES, locale, setLocale, t } from '../i18n/index.svelte';
  import { computeMode, serverAvailable, setComputeMode, type ComputeMode } from '../server/compute.svelte';

  const modes: ComputeMode[] = ['client', 'server', 'auto'];

  import type { View } from '../ui.svelte';
  let { view = $bindable(), views }: { view: View; views: { id: View; label: string }[] } = $props();
</script>

<header>
  <div class="brand">
    <svg viewBox="0 0 32 32" width="22" height="22" aria-hidden="true"
      ><circle cx="11" cy="13" r="3.2" fill="var(--accent)" /><circle
        cx="21"
        cy="13"
        r="3.2"
        fill="var(--accent)"
      /><path d="M7 22h18" stroke="var(--blue)" stroke-width="2.4" stroke-linecap="round" /></svg
    >
    <span>{t('app.title')}</span>
  </div>
  <nav>
    {#each views as v (v.id)}
      <button class:on={view === v.id} onclick={() => (view = v.id)} data-testid={`nav-${v.id}`}>{v.label}</button>
    {/each}
  </nav>
  <div class="right">
    {#if serverAvailable()}
      <div class="seg compute" title={t('mode.hint')} data-testid="compute-switch">
        {#each modes as m (m)}
          <button class:on={computeMode.mode === m} onclick={() => setComputeMode(m)} data-testid={`compute-${m}`}
            >{t(`compute.${m}`)}</button
          >
        {/each}
      </div>
    {:else}
      <span class="badge mono" title={t('mode.hint')} data-testid="mode-badge">
        {APP_MODE === 'client-only' || !caps.compute ? t('mode.clientOnly') : t('mode.full')}
      </span>
    {/if}
    <div class="seg lang">
      {#each LOCALES as l (l.id)}
        <button class:on={locale() === l.id} onclick={() => setLocale(l.id)}>{l.label}</button>
      {/each}
    </div>
  </div>
</header>

<style>
  header {
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 0 16px;
    height: 48px;
    border-bottom: 1px solid var(--line);
    background: var(--bg);
  }
  .brand {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    letter-spacing: 0.01em;
  }
  nav {
    display: flex;
    gap: 4px;
    flex: 1;
  }
  nav button {
    background: none;
    border: 0;
    color: var(--muted);
    padding: 14px 10px;
    border-radius: 0;
    border-bottom: 2px solid transparent;
  }
  nav button.on {
    color: var(--text);
    border-bottom-color: var(--accent);
  }
  .right {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .badge {
    font-size: 11px;
    color: var(--muted);
    border: 1px solid var(--line);
    padding: 2px 8px;
    border-radius: 99px;
  }
  .compute button {
    padding: 3px 8px;
    font-size: 12px;
  }
  .lang button {
    padding: 3px 8px;
    font-size: 12px;
  }
  @media (max-width: 820px) {
    .brand span,
    .badge {
      display: none;
    }
    header {
      gap: 8px;
    }
  }
</style>
